export class Faq {
  constructor({
    id = null,
    pergunta = null,
    resposta = null,
    palavrasChave = Array(),
    ativo = null,
  }) {
    this.id = id;
    this.pergunta = pergunta;
    this.resposta = resposta;
    this.palavrasChave = palavrasChave;
    this.ativo = ativo;
  }
  static Build() {
    return new Faq({
      id: null,
      pergunta: null,
      resposta: null,
      palavrasChave: Array(),
      ativo: null,
    });
  }
  format() {
    return this;
  }
}
